module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.pass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pass", $$v)
      },
      expression: "formData.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newpass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.newpass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newpass", $$v)
      },
      expression: "formData.newpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码",
      "prop": "repass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.repass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "repass", $$v)
      },
      expression: "formData.repass"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e20f010"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/user/PassForm.vue
// module id = 1160
// module chunks = 1